import { useReduxState } from 'hooks';
import { PageInnerContent, PageSidebar } from 'components/page';
import { CoursePage } from 'components/courses/common';

import type { IconProp } from 'components/common/icons/Icon';

const SettingsPage = ({ activeLink = '', children }) => {
  const {
    messages,
    pageState: { course }
  } = useReduxState();

  const sidebarLinks = course
    ? [
        {
          as: `/admin/courses/${course.slug}/settings`,
          href: '/admin/courses/[courseSlug]/settings',
          icon: 'cog' as const,
          title: messages.settingsCourseSettings
        },
        {
          as: `/admin/courses/${course.slug}/settings/completion`,
          href: '/admin/courses/[courseSlug]/settings/completion',
          icon: 'sliders-h' as const,
          ...(course.completionEnabled
            ? { successItem: messages.commonEnabled }
            : {}),
          title: messages.settingsCompletion
        },
        {
          as: `/admin/courses/${course.slug}/settings/competencies`,
          href: '/admin/courses/[courseSlug]/settings/competencies',
          icon: 'medal' as const,
          title: messages.commonCompetencies
        },
        {
          as: `/admin/courses/${course.slug}/settings/schedule`,
          href: '/admin/courses/[courseSlug]/settings/schedule',
          icon: ['far', 'calendar-alt'] as IconProp,
          title: messages.courseMandatoryAndTargetSchedule
        },
        {
          as: `/admin/courses/${course.slug}/settings/language`,
          href: '/admin/courses/[courseSlug]/settings/language',
          icon: ['fas', 'language'] as IconProp,
          title: messages.courseLanguageSettings
        },
        {
          as: `/admin/courses/${course.slug}/settings/integrations`,
          href: '/admin/courses/[courseSlug]/settings/integrations',
          icon: 'share-alt' as const,
          title: messages.settingsIntegrations
        }
      ]
    : null;

  return (
    <CoursePage
      activeLink="settings"
      course={course}
      ensureAdminPermission="edit-settings"
      withSidebar={true}
    >
      <PageSidebar
        active={`/admin/courses/${course?.slug}/settings${activeLink}`}
        links={sidebarLinks}
      />
      <PageInnerContent>{children}</PageInnerContent>
    </CoursePage>
  );
};

export default SettingsPage;
